import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DomSanitizer } from "@angular/platform-browser";
import {AddMovieService} from "../add-movie/add-movie.service";

@Injectable()
export class AdminAddMovieService {
  constructor(private http: HttpClient, private sanitizer: DomSanitizer, private delegate: AddMovieService) {}

  suggestImdbUrl(data, successCallback, errorCallback) {
      return this.delegate.suggestImdbUrl(data, successCallback, errorCallback)
  }

  addMovie(data, successCallback, errorCallback) {
    this.http.post("/api/admin/add-movie", data).subscribe(
      response => {
        successCallback(response);
      },
      response => {
        errorCallback(response);
      },
      () => {
        //console.log("Add movie post complete");
      }
    );
  }

  trustUrl(url) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  trustResourceUrl(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
